import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import Janus from 'janus-gateway';
import "webrtc-adapter";
import UserLoginContext from "../../context/userLoginContext";
// import {toast} from "react-toastify";
import "../../styles/component/peer-calling.scss";
// import success = toast.success;
import {
    AudioOutlined, CameraOutlined,
    PhoneOutlined,
    VideoCameraAddOutlined,
} from "@ant-design/icons";



const JanusP2PCall = () => {
    const [janus, setJanus] = useState<Janus | null>(null);
    const pluginHandleRef = useRef<any>(null);  // 🔹 Use Ref Instead of State
    const [loginUser, setLoginUser] = useState("");
    const [inCall, setInCall] = useState(false);
    const [userList, setUserList] = useState([]);
    const {user} = useContext(UserLoginContext);
    const [incomingCall, setIncomingCall] = useState(null);
    const [callJsep, setCallJsep] = useState(null);
    const [isRecording, setIsRecording] = useState(false);

    const [isMuted, setIsMuted] = useState(true);

    const [isCameraOn, setIsCameraOn] = useState(true);


    const localVideoRef = useRef<any>(null);
    const remoteVideoRef = useRef<any>(null);
    const remoteAudioRef = useRef<any>(null);
    const ringtoneRef = useRef(new Audio('/apple-iphone-501.mp3')); // 🔹 Load ringtone

    // ✅ Play ringtone when there's an incoming call
    const playRingtone = () => {
        const ringtone = ringtoneRef.current;
        if (document.visibilityState === "visible") {  // Check tab visibility
            ringtone.loop = true;
            ringtone.volume = 1.0;
            ringtone.play().catch((err) => {
                console.warn("🔇 Ringtone play blocked:", err);
            });
        }
    };

    // ✅ Stop ringtone
    const stopRingtone = () => {
        const ringtone = ringtoneRef.current;
        ringtone.pause();
        ringtone.currentTime = 0;
    };

    const startJanus = useCallback(() => {
        const janusInstance = new Janus({
            server: "wss://janus2.okruti.com/janus",  // Update with your Janus server
            success: () => {
                janusInstance.attach({
                    plugin: "janus.plugin.videocall",
                    success: (plugin: any) => {
                        console.log("✅ Janus Plugin Attached:", plugin);
                        pluginHandleRef.current = plugin; // 🔹 Store in ref
                    },
                    error: (error: any) => console.error("❌ Plugin Attach Error", error),
                    onmessage: (msg: any, jsep: any) => handleIncomingMessage(msg, jsep!),
                    onremotetrack: (event: any) => {
                        if (event.kind === 'video') {
                            const remoteStream = new MediaStream();
                            remoteStream.addTrack(event);  // Add the remote track to the media stream

                            if (remoteVideoRef.current instanceof HTMLVideoElement) {
                                remoteVideoRef.current.srcObject = remoteStream; // Corrected to use remoteVideoRef
                            }
                        }
                        if (event.kind === 'audio') {
                            const audioStream = new MediaStream();
                            audioStream.addTrack(event);  // Add the remote track to the media stream

                            if (remoteAudioRef.current instanceof HTMLAudioElement) {
                                remoteAudioRef.current.srcObject = audioStream; // Corrected to use remoteAudioRef
                            }
                        }
                    },
                });
            },
            error: (error: any) =>
                console.error("❌ Janus Connection Error", error),
        });
        setJanus(janusInstance);
    }, []);

    useEffect(() => {

        if (user && !user.id) {
            return;
        }
        // intialize janus on login
        Janus.init({debug: true, callback: startJanus});
        setTimeout(() => {
            registerUser(user);
        }, 2000)
    }, [startJanus, user]);


    const registerUser = (user: any) => {
        if (!pluginHandleRef.current) return;
        // Register request for the P2P Video Call plugin
        // const userId = Date.now(); // uuid
        const register = {
            request: "register",
            username: `${user.name.firstName};${user.id}`, // Include unique ID in username
        };
        pluginHandleRef.current.send({
            message: register
        });
        getUserList();
        setLoginUser(register.username)
    };

    const getUserList = () => {
        if (!pluginHandleRef.current) return;
        pluginHandleRef.current.send({
            message: {request: "list"},
        });
    }

    const callUser = (callee: any) => {
        if (!pluginHandleRef.current || !callee) return;
        navigator.mediaDevices.getUserMedia({video: true, audio: true})
            .then((stream) => {
                if (localVideoRef.current) {
                    localVideoRef.current.srcObject = stream;
                }
                pluginHandleRef.current.createOffer({
                    media: {video: true, audio: true},
                    stream,
                    success: (jsep: any) => {
                        // console.log("📞 Calling user:", callee);
                        pluginHandleRef.current.send({
                            message: {request: "call", username: callee},
                            jsep
                        });
                    },
                    error: (error: any) => console.error("❌ Offer Error", error),
                });
            })
            .catch((err) => console.error("❌ GetUserMedia Error", err));
    };

    const handleIncomingMessage = (msg: any, jsep: any) => {
        if (!pluginHandleRef.current) {
            // console.warn("⚠️ Plugin handle not ready yet. Retrying...");
            setTimeout(() => handleIncomingMessage(msg, jsep), 100); // 🔹 Retry after 100ms
            return;
        }

        // console.log("📩 Incoming Message:", msg);

        if (jsep) {
            // console.log("✅ Handling Remote JSEP:", jsep);
            pluginHandleRef.current.handleRemoteJsep({jsep});
        }
        setCallJsep(jsep);

        if (msg.result?.event === "incomingcall") {
            const caller = msg.result.username.split(';')[0];
            setIncomingCall(caller);
            playRingtone(); // ✅ Play ringtone on incoming call
            // if (window.confirm(`📞 Incoming call from ${caller}. Accept?`)) {
            //     acceptCall(jsep);
            // } else {
            //     declineCall();
            // }
        }

        if (msg.result?.event === "accepted") {
            // console.log("✅ Call Accepted:", msg);
            stopRingtone(); // ✅ Stop ringtone when call is accepted
            setInCall(true);
        }

        if (msg.result?.event === "hangup") {
            // console.log("🚨 The other user hung up!");

            // 🔹 Stop local video stream
            if (localVideoRef.current && localVideoRef.current.srcObject) {
                localVideoRef.current.srcObject.getTracks()
                    .forEach((track: any) => track.stop());
                localVideoRef.current.srcObject = null;
            }

            // 🔹 Stop remote video stream
            if (remoteVideoRef.current && remoteVideoRef.current.srcObject) {
                remoteVideoRef.current.srcObject
                    .getTracks()
                    .forEach((track: any) => track.stop());
                remoteVideoRef.current.srcObject = null;
            }

            // 🔹 Stop remote audio stream
            if (remoteAudioRef.current && remoteAudioRef.current.srcObject) {
                remoteAudioRef.current.srcObject
                    .getTracks()
                    .forEach((track: any) => track.stop());
                remoteAudioRef.current.srcObject = null;
            }

            // 🔹 Reset states
            setInCall(false);
            setIncomingCall(null);
        }

        if (msg.videocall === "event") {

            if (msg.record !== undefined) {

                if (msg.record) {

                    // console.log("🎬 Recording started!");

                    setIsRecording(true);

                } else {

                    // console.log("🛑 Recording stopped!");

                    setIsRecording(false);

                }

            }


            if (msg.filename) {

                console.log("📁 Recording saved as:", msg.filename);

            }

        }

        if (msg.result && msg.result['list']) {
            // console.log('msg.result.list', msg.result.list);
            setUserList(msg.result.list);
        }
    };

    const acceptCall = (jsep: any) => {
        navigator.mediaDevices.getUserMedia({video: true, audio: true})
            .then((stream) => {
                stopRingtone(); // ✅ Stop ringtone when call is accepted
                if (localVideoRef.current) {
                    localVideoRef.current.srcObject = stream;
                }
                pluginHandleRef.current.createAnswer({
                    media: {video: true, audio: true},
                    stream,
                    jsep,
                    success: (jsepAnswer: any) => {
                        pluginHandleRef.current.send({
                            message: {request: "accept"},
                            jsep: jsepAnswer
                        });
                    },
                    error: (error: any) => console.error("❌ Answer Error", error),
                });
            })
            .catch((err) => console.error("❌ GetUserMedia Error", err));

        setIncomingCall(null);
    };

    const declineCall = () => {
        // console.log("❌ Call rejected");

        // 🔹 Stop local video stream if any
        if (localVideoRef.current && localVideoRef.current.srcObject) {
            localVideoRef.current.srcObject
                .getTracks()
                .forEach((track: any) => track.stop());
            localVideoRef.current.srcObject = null;
        }
        stopRingtone(); // ✅ Stop ringtone when call is declined
        pluginHandleRef.current.send({message: {request: "hangup"}});
        setIncomingCall(null);
    };

    const hangUp = () => {
        // Stop the local video stream
        if (localVideoRef.current && localVideoRef.current.srcObject) {
            const localStream = localVideoRef.current.srcObject;
            const tracks = localStream.getTracks();
            tracks.forEach((track: any) => track.stop()); // Stop each track of the local stream
            localVideoRef.current.srcObject = null; // Remove the local video feed
        }

        // Stop the remote video stream
        if (remoteVideoRef.current && remoteVideoRef.current.srcObject) {
            const remoteStream = remoteVideoRef.current.srcObject;
            const tracks = remoteStream.getTracks();
            tracks.forEach((track: any) => track.stop()); // Stop each track of the remote stream
            remoteVideoRef.current.srcObject = null; // Remove the remote video feed
            if (remoteAudioRef.current) {
                remoteAudioRef.current.srcObject = null; // Remove the remote audio feed
            }
        }

        // Send hangup message to Janus
        pluginHandleRef.current.send({message: {request: "hangup"}});

        // Reset the call state
        setInCall(false); // Set the state to reflect that the call is ended
        setIncomingCall(null); // Reset the incoming call state if it was set
    };

    const startRecording = () => {
        if (!pluginHandleRef.current) return;
        // const recordingName = `call_${Date.now()}`; // Unique recording name
        let path = `/opt/janus/share/janus/recordings/${loginUser}`;
        pluginHandleRef.current.send({
            message: {request: "set", record: true, filename: path}, success: (response: any) => {
                console.log("✅ Janus accepted recording request:");
            },
            error: (err: any) => {
                console.error("❌ Janus recording error:", err);
            }
        });
        setIsRecording(true); // Toggle UI state
        // console.log("🎬 Recording Start Request Sent:", loginUser);
    };

    const stopRecording = () => {
        if (!pluginHandleRef.current) return;
        pluginHandleRef.current.send({
            message: {request: "set", record: false}, success: (response: any) => {
                console.log("✅ Janus stopped recording request:");
            },
            error: (err: any) => {
                console.error("❌ Janus recording error:", err);
            }
        });
        setIsRecording(false);
        // console.log("⏹️ Recording Stop Request Sent");
    };


    const toggleAudio = () => {
        if (!pluginHandleRef.current) return;
        pluginHandleRef.current.send({
            message: {request: "set", audio: !isMuted}, success: (response: any) => {
                console.log("✅ Janus audio :", isMuted ? "enabled" : "disabled");
            },
            error: (err: any) => {
                console.error("❌ Janus Audio error:", err);
            }
        });
        setIsMuted(!isMuted); // Toggle UI state
    };

    const createBlankVideoTrack = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 640;
        canvas.height = 480;
        const ctx: any = canvas.getContext("2d");

        ctx.fillStyle = "black";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        return canvas.captureStream(30).getVideoTracks()[0]; // 30 FPS blank track
    };

    const toggleVideo = () => {
        if (!pluginHandleRef.current) return;

        pluginHandleRef.current.send({ message: { request: "set", video: !isCameraOn}, success: (response: any) => {
                console.log("✅ Janus Video ", isCameraOn ? "enabled" : "disabled");
                // Stop the local video stream
                if (localVideoRef.current && localVideoRef.current.srcObject) {
                    const localStream = localVideoRef.current.srcObject;
                    const videoTrack = localStream.getVideoTracks()[0];
                    if (videoTrack && isCameraOn) {
                        videoTrack.enabled = false;
                        videoTrack.stop(); // Stop original video track
                        // Create a blank track to replace the video
                        const blankTrack = new MediaStream();
                        const blankVideoTrack = createBlankVideoTrack();
                        blankTrack.addTrack(blankVideoTrack);
                        localStream.removeTrack(videoTrack);
                        localVideoRef.current.srcObject =blankTrack;
                        // localVideoRef.enabled = false;

                        // console.log("🚫 Camera turned off, blank track sent.");
                        setIsCameraOn(!isCameraOn);
                    }else{
                        navigator.mediaDevices.getUserMedia({ video: true, audio: true })
                            .then((stream) => {
                                localVideoRef.current.srcObject = stream;
                                videoTrack.enabled = true;
                                setIsCameraOn(!isCameraOn);
                            })
                            .catch((err) => console.error("❌ GetUserMedia Error", err));
                    }
                    // tracks.forEach(track => track.stop()); // Stop each track of the local stream
                }

            },
            error: (err: any) => {
                console.error("❌ Janus recording error:", err);
            }});
        // console.log("⏹️ Recording Stop Request Sent");
    };

    return (
        <div className={"hrms-meeting"}>
            <h2 className={"hrms-meeting__heading"}>HRMS P2P Video Call</h2>

            <div className={"hrms-meeting__main-section"}>
                <div>
                    <section className={"hrms-meeting__available-users"}>
                        <h3 className={"hrms-meeting__available-users__heading"}>Available Users</h3>
                        {/*<button className={"hrms-meeting__button available-users"} onClick={getUserList}>Get List</button>*/}
                        {
                            userList.length <= 0 ?
                                <p className={"hrms-meeting__available-users__no-user"}>There is no user available
                                    currently!!</p> :
                                <ul className={"hrms-meeting__available-users__list-items"}>
                                    {userList.map((user: any) => (
                                        <li key={user} className={"hrms-meeting__available-users__item"}>
                                            {user.split(';')[0]}
                                            {user !== loginUser &&
                                            <button className={"hrms-meeting__button call"}
                                                    onClick={() => callUser(user)}>
                                                <PhoneOutlined />
                                            </button>}
                                        </li>
                                    ))}
                                </ul>
                        }
                    </section>


                    <div className={"hrms-meeting__video-section__caller__section"}>
                        <video className={"hrms-meeting__video-section__caller"} ref={localVideoRef} autoPlay muted
                               playsInline
                        />
                        <div className={"hrms-meeting__video-section__caller__buttons"}>
                            {inCall && (
                                <button className={`hrms-meeting__video-section__caller__button recording`}
                                        style={{backgroundColor: isRecording ? 'green' : '#e74c3c'}}
                                        onClick={isRecording ? stopRecording : startRecording}>
                                    {isRecording ? <VideoCameraAddOutlined /> : <VideoCameraAddOutlined />}
                                </button>
                            )}

                            {inCall && (
                                <button className={`hrms-meeting__video-section__caller__button audio`}
                                        style={{backgroundColor: isMuted ? 'green' : '#e74c3c'}} onClick={toggleAudio}>
                                    {isMuted ? <AudioOutlined /> : <AudioOutlined />}
                                </button>
                            )}

                            {inCall && (
                                <button className={`hrms-meeting__video-section__caller__button camera`}
                                        style={{backgroundColor: isCameraOn ? 'green' : '#e74c3c'}} onClick={toggleVideo}>
                                    {isCameraOn ? <CameraOutlined twoToneColor={'#862633'}/> : <CameraOutlined />}
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <section className={"hrms-meeting__video-section"}>
                    <div className={"hrms-meeting__video-section__callee-section"}>
                        <video className={"hrms-meeting__video-section__callee"} ref={remoteVideoRef} autoPlay
                               playsInline
                        />
                        {inCall && <button className={"hrms-meeting__button hangup"} onClick={hangUp}>Hang Up</button>}
                    </div>
                    <audio ref={remoteAudioRef} autoPlay hidden/>
                </section>
            </div>
            {/* 🎥 **Recording Toggle Button** */}



            {/*<div>*/}
                {/*<video ref={localVideoRef} autoPlay muted playsInline style={{width: "300px"}}/>*/}
                {/*<video ref={remoteVideoRef} autoPlay playsInline style={{width: "300px"}}/>*/}
                {/*<audio ref={remoteAudioRef} autoPlay hidden/>*/}
            {/*</div>*/}

            {incomingCall && (
                <div className={"hrms-meeting__incoming-popup"}>
                    <p className={"hrms-meeting__incoming-popup__heading"}>📞 Incoming call from {incomingCall}</p>
                    <button className={"hrms-meeting__button accept"} onClick={() => acceptCall(callJsep)}>✅ Accept
                    </button>
                    <button className={"hrms-meeting__button decline"} onClick={() => declineCall()}>❌ Decline</button>
                </div>
            )}
        </div>
    );
};
export default JanusP2PCall;

